<template>
  <div class="solution_item">
    <bg-intro :bgIntroData="bgIntroData" :showDownload="false"></bg-intro>
    <div class="intro-wrapper">
      <div class="intro-content">
        <div class="img-wrapper text-center">
          <img src="../../assets/solution/yydj1.webp" alt="语音" />
        </div>
        <h3>产品体验</h3>
        <div class="audio-wrapper space-around">
          <div class="left-wrapper audio-item">
            <p class="audio-title">原音频</p>
            <div class="audio-content">
              <div class="control-wrapper flex-start">
                <span class="title">压缩码率：</span>
                <div class="btn-wrapper">
                  <button class="item" :class="currentIndex === 0 ? 'active' : ''" @click="chose(0)">450bps</button>
                  <button class="item" :class="currentIndex === 1 ? 'active' : ''" @click="chose(1)">700bps</button>
                  <button class="item" :class="currentIndex === 2 ? 'active' : ''" @click="chose(2)">1200bps</button>
                  <button class="item" :class="currentIndex === 3 ? 'active' : ''" @click="chose(3)">2400bps</button>
                </div>
              </div>
              <div class="audio-content-item">
                <div class="audio">
                  <audio controls>
                    <source :src="`${baseUrl}/api/console/files/material/audio/original-audio.wav`" type="audio/mp3" />
                  </audio>
                  <!-- <span>大小{{ originSize | formatSize }}</span> -->
                </div>
              </div>
            </div>
          </div>

          <div class="right-wrapper audio-item">
            <p class="audio-title">压缩后音频</p>
            <div class="audio-content">
              <div class="unzip-title flex-start">
                <p class="title">解压码率：</p>
                <span>{{ codeRate }}</span>
              </div>
              <div class="audio-content-item">
                <div class="audio flex-start">
                  <transition name="fade" mode="in-out">
                    <audio key="450bps" v-if="currentIndex === 0" controls>
                      <source :src="audioSrcData[0].url" type="audio/mp3" />
                    </audio>
                  </transition>

                  <transition name="fade" mode="in-out">
                    <audio key="700bps" v-if="currentIndex === 1" controls>
                      <source :src="audioSrcData[1].url" type="audio/mp3" />
                    </audio>
                  </transition>

                  <transition name="fade" mode="out-in">
                    <audio key="1200bps" v-if="currentIndex === 2" controls>
                      <source :src="audioSrcData[2].url" type="audio/mp3" />
                    </audio>
                  </transition>

                  <transition name="fade" mode="out-in">
                    <audio key="2400bps" v-if="currentIndex === 3" controls>
                      <source :src="audioSrcData[3].url" type="audio/mp3" />
                    </audio>
                  </transition>

                  <!-- <span key="size">大小{{ compressSize | formatSize }}</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <h2>使用北斗三号五级卡（1750字节）情况下，最长能传输31秒语音</h2>

        <div class="img-item">
          <img src="../../assets/solution/yydj2.webp" alt="语音介绍" />
          <img src="../../assets/solution/yydj3.webp" alt="语音介绍" />
        </div>
        <div class="qr-code">
          <img src="../../assets/home/code.webp" alt="二维码" />
          <router-link to="/solution/custom">需要定制APP?</router-link>
        </div>
      </div>
    </div>
    <!-- <field :fieldData="fieldData"></field> -->
    <highlight :highlightsData="highlightData"></highlight>
    <div class="brief-wrapper">
      <h3>关键技术</h3>
      <brief :briefData="briefData[0]" :isReverse="true"></brief>
      <brief :briefData="briefData[1]" :isReverse="false"></brief>
      <brief :briefData="briefData[2]" :isReverse="true"></brief>
    </div>
    <product></product>
    <beDevelop></beDevelop>
  </div>
</template>

<script>
import bgIntro from '@/components/common/solution/bgIntro.vue';
import field from '@/components/common/solution/field.vue';
import highlight from '@/components/common/solution/highlight.vue';
import brief from '@/components/common/solution/brief.vue';
import product from '@/components/common/solution/product.vue';
import beDevelop from '@/components/common/beDevelop.vue';
import axios from 'axios';
import config from '@/config';
export default {
  metaInfo: {
    title: '北斗短报文应急语音对讲系统',
    meta: [
      {
        name: 'keywords',
        content: '北斗三号短报文语音传输,北斗语音对讲,北斗语音压缩,北斗语音通信',
      },
      {
        name: 'description',
        content: '北斗卫星语音压缩算法极致压缩比：采样率8kHz， 码率是450bps， 使用北斗三号五级卡（1750字节）情况下，最长能传输31秒语音。集成学习的波速形成语音增强算法，能清晰分辨男声或女声，分辨使用者身份。',
      },
    ],
  },
  data() {
    return {
      bgIntroData: {
        bgSrc: require('../../assets/solution/yydj-banner.webp'),
        title: '国家科技重大专项成果',
        intro: '极致压缩比、超高压缩效率、高保真效果',
      },
      fieldData: {
        fieldTitle: '应用领域',
        items: [
          {
            id: 'field1',
            imgSrc: require('../../assets/solution/1.webp'),
            intro: '应急通信',
          },
          {
            id: 'field2',
            imgSrc: require('../../assets/solution/1.webp'),
            intro: '野外救援',
          },
          {
            id: 'field3',
            imgSrc: require('../../assets/solution/1.webp'),
            intro: '海事渔政',
          },
          {
            id: 'field4',
            imgSrc: require('../../assets/solution/1.webp'),
            intro: '极限赛事',
          },
          {
            id: 'field5',
            imgSrc: require('../../assets/solution/1.webp'),
            intro: '户外勘探',
          },
          {
            id: 'field6',
            imgSrc: require('../../assets/solution/1.webp'),
            intro: '森林防火',
          },
        ],
      },
      highlightData: {
        title: '服务优势',
        items: [
          {
            id: 'h1',
            title: '极致压缩比',
            intro: '采样率8kHz， 码率是450bps， 使用北斗三号五级卡（1750字节）情况下，最长能传输28秒语音。',
            imgSrc: require('../../assets/solution/yyys-fuzb1.webp'),
            color: '#EFA65E',
          },
          {
            id: 'h2',
            title: '超高压缩效率',
            intro: '从语音输入到压缩完成，整个过程仅需200毫秒。',
            imgSrc: require('../../assets/solution/yyys-fuzb2.webp'),
            color: '#63B59F',
          },
          {
            id: 'h3',
            title: '高保真效果',
            intro: '集成学习的波速形成语音增强算法，能清晰分辨男声或女声，分辨使用者身份。',
            imgSrc: require('../../assets/solution/yyys-fuzb3.webp'),
            color: '#4173FB',
          },
        ],
      },
      briefData: [
        {
          title: '语音过渡段清/浊音判决技术',
          imgSrc: require('../../assets/solution/guanjian1.webp'),
          introItems: [
            {
              id: 'intro1',
              // subtitle: '平板应用app支持全国卫星/标准离线地图下载，储存在平板电脑本地；  ',
              intro:
                '基于上采样的基音周期估计算法，过渡段清/浊音判决以及基于过渡段的非对称窗LPC分析方法，有效提升语音质量。',
            },
          ],
        },
        {
          title: '波束形成与深度学习相结合的语音增强算法',
          imgSrc: require('../../assets/solution/guanjian2.webp'),
          introItems: [
            {
              id: 'intro1',
              // subtitle: '复高斯混合模型估计时频掩蔽和方向矢量',
              intro: '利用复高斯混合模型估计时频掩蔽和方向矢量的波束形成方法，有效去除环境噪声，增强语音效果。',
              // intro: '北斗船载终端定时5分钟/次（可调）向后台上报终端位置信息',
            },
          ],
        },
        {
          title: '低码率环境高效可靠语音传输协议优化技术',
          imgSrc: require('../../assets/solution/guanjian3.webp'),
          introItems: [
            {
              id: 'intro1',
              intro:
                '基于编码冗余的抗长延时语音传输协议；自适应信道速率的动态分包算法；基于遗传算法的链路资源智能调度策略。有效支持丢包重传，支持用户动态调整，提高传输效率。',
              // intro: '北斗船载终端定时5分钟/次（可调）向后台上报终端位置信息',
            },
          ],
        },
      ],
      currentIndex: 0,
      // audioSrc: '${config.baseUrl}/api/console/files/material/audio/compression-audio-450.wav',
      audioSrcData: [
        {
          desc: '450bps',
          url: `${config.baseUrl}/api/console/files/material/audio/compression-audio-450.wav`,
          infoUrl: `${config.baseUrl}/api/console/files/material/audio/compression-audio-450.wav/info`,
        },
        {
          desc: '700bps',
          url: `${config.baseUrl}/api/console/files/material/audio/compression-audio-750.wav`,
          infoUrl: `${config.baseUrl}/api/console/files/material/audio/compression-audio-750.wav/info`,
        },
        {
          desc: '1200bps',
          url: `${config.baseUrl}/api/console/files/material/audio/compression-audio-1200.wav`,
          infoUrl: `${config.baseUrl}/api/console/files/material/audio/compression-audio-1200.wav/info`,
        },
        {
          desc: '2400bps',
          url: `${config.baseUrl}/api/console/files/material/audio/compression-audio-2400.wav`,
          infoUrl: `${config.baseUrl}/api/console/files/material/audio/compression-audio-2400.wav/info`,
        },
      ],
      codeRate: '450bps',
      baseUrl: config.baseUrl,
    };
  },
  filters: {
    // 格式化文件大小
    formatSize: function (fileSize) {
      if (fileSize < 1024) {
        return `${fileSize}KB`;
      } else if (fileSize < 1024 * 1024) {
        let temp = fileSize / 1024;
        temp = temp.toFixed(2);
        return `${temp}MB`;
      } else if (fileSize < 1024 * 1024 * 1024) {
        let temp = fileSize / (1024 * 1024);
        temp = temp.toFixed(2);
        return `${temp}GB`;
      }
    },
  },
  methods: {
    chose(index) {
      this.currentIndex = index;
      this.codeRate = this.audioSrcData[this.currentIndex].desc;
      // this.$nextTick(() => {
      //   this.getFileInfo();
      // });
    },
    // 获取选中的音频信息
    async getFileInfo() {
      try {
        const reqUrl = this.audioSrcData[this.currentIndex].infoUrl;
        const res = await axios.get(reqUrl);
        this.compressSize = res.data && res.data.size;
      } catch (error) {
        console.log(error);
      }
    },
    // 获取原音频文件信息
    async getOriginFileInfo() {
      try {
        const reqUrl = `${config.baseUrl}/api/console/files/material/audio/original-audio.wav/info`;
        const res = await axios.get(reqUrl);
        this.originSize = res.data && res.data.size;
      } catch (error) {
        console.log(error);
      }
    },
  },

  components: {
    bgIntro,
    field,
    highlight,
    brief,
    product,
    beDevelop,
  },

  // created() {
  //   this.getOriginFileInfo();
  //   this.getFileInfo();
  // },
};
</script>

<style lang="scss" scoped>
.solution_item {
  width: 100%;
  .intro-wrapper {
    width: 1100px;
    margin: 0 auto;
    padding: 70px 0;
    h3 {
      margin-top: 60px;
      margin-bottom: 60px;
      text-align: center;
    }
    .intro-content {
      .img-wrapper {
        img {
          max-width: 600px;
          margin-bottom: 25px;
        }
      }
      .audio-wrapper {
        color: #4173fb;
        .audio-item {
          // width: 35%;
          .audio-title {
            text-align: center;
            font-size: 18px;
            margin-bottom: 20px;
            color: #0d0e24;
          }
          .audio-content {
            box-sizing: border-box;
            width: 490px;
            height: 210px;
            background: #ffffff;
            box-shadow: 0px 0px 12px 0px rgba(13, 14, 36, 0.05);
            border-radius: 15px;
            padding: 30px;
            .unzip-title {
              margin-left: 10px;
              height: 34px;
            }
            .btn-wrapper {
              margin-left: 10px;
              .item {
                font-size: 16px;
                border: none;
                outline: none;
                height: 34px;
                line-height: 34px;
                width: 80px;
                margin-right: 4px;
                border-radius: 2px;
                color: #4173fb;
                background-color: transparent;
                text-align: center;
              }
            }
            .audio-content-item {
              text-align: center;
              margin-top: 48px;
              .audio {
                position: relative;
                width: 380px;
                margin: 0 auto;
              }
              audio {
                width: 100%;
                overflow: hidden;
              }
            }
          }
        }
      }
      h2 {
        font-size: 24px;
        font-weight: 400;
        color: #0d0e24;
        margin-top: 70px;
        margin-bottom: 70px;
        text-align: center;
      }
      .img-item {
        text-align: center;
      }
      .qr-code {
        width: 220px;
        height: 220px;
        margin: 0 auto;
        margin-top: 20px;
        text-align: center;
        margin-bottom: 40px;
        img {
          max-width: 100%;
        }
        a {
          display: inline-block;
          font-size: 14px;
          font-weight: 400;
          color: #226bfb;
          margin-top: 15px;
        }
      }
    }
  }

  .brief-wrapper {
    margin-top: 70px;
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #0d0e24;
      text-align: center;
    }
  }
}
.active {
  background-color: #4173fb !important;
  color: #fff !important;
}
.fade-enter-active,
.fade-leave-active {
  opacity: 1;
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  position: absolute;
  opacity: 0;
}
</style>